import { MessageLevel } from "cortex/ui/static/@cortex/messages/enums/message_level_pb";
import { PayloadType } from "cortex/ui/static/@cortex/messages/enums/payload_type_pb";
import { TaskStatus } from "cortex/ui/static/@cortex/messages/enums/task_status_pb";

import { LEVEL_ERROR, LEVEL_INFO, LEVEL_SUCCESS, LEVEL_WARN } from "./messages";

// These must match cortex-api "messages/constants.py"
const CHAN_DEVICE_BULK_EDIT = "device::bulk-edit" as const;
const CHAN_DEVICE_BULK_REGISTER = "device::bulk-register" as const;
const CHAN_GENERIC_TASK = "task::generic" as const;

const MESSAGE_LEVEL_MAP: Record<number, string> = {
  [MessageLevel.ERROR as unknown as number]: LEVEL_ERROR,
  [MessageLevel.WARNING as unknown as number]: LEVEL_WARN,
  [MessageLevel.INFO as unknown as number]: LEVEL_SUCCESS,
  [MessageLevel.DEBUG as unknown as number]: LEVEL_INFO,
};

const TASK_STATUS_MAP: Record<number, string> = {
  [TaskStatus.SUCCESS as unknown as number]: "completed",
  [TaskStatus.FAILURE as unknown as number]: "failed",
  [TaskStatus.STARTED as unknown as number]: "started",
  [TaskStatus.QUEUED as unknown as number]: "queued",
};

const VALID_MESSAGE_TYPES: ReadonlyArray<number> = [
  PayloadType.MESSAGE as unknown as number,
  PayloadType.PROGRESS as unknown as number,
  PayloadType.TASK_RESULT as unknown as number,
];

export {
  CHAN_DEVICE_BULK_EDIT,
  CHAN_DEVICE_BULK_REGISTER,
  CHAN_GENERIC_TASK,
  MESSAGE_LEVEL_MAP,
  TASK_STATUS_MAP,
  VALID_MESSAGE_TYPES,
};
